// src/utilities/favoritesUtils.js

/**
 * Finds a matching favorite record for a given property.
 *
 * Checks three cases to handle both legacy and current favorite formats:
 *   1. property_id matches propertyId          (tax/deed/cert sales, old foreclosure records)
 *   2. prop_int_id matches propertyId (string) (foreclosures where propertyId was stored as prop_int_id)
 *   3. prop_int_id matches property.id         (foreclosures where the case ID was stored as prop_int_id)
 *
 * @param {object[]} favorites - favorites array from Redux
 * @param {object}   property  - full property object
 * @returns {object|undefined} the matching favorite record, or undefined if not found
 */
export const findFavorite = (favorites, property) => {
  if (!favorites || !property) return undefined;
  return favorites.find(
    (fav) =>
      (fav.property_id && fav.property_id === property.propertyId) ||
      (fav.prop_int_id && fav.prop_int_id === String(property.propertyId)) ||
      (fav.prop_int_id && fav.prop_int_id === String(property.id))
  );
};

/**
 * Returns true if the property exists in the user's favorites.
 *
 * @param {object[]} favorites - favorites array from Redux
 * @param {object}   property  - full property object
 * @returns {boolean}
 */
export const isPropertyFavorite = (favorites, property) =>
  !!findFavorite(favorites, property);